// extracted by mini-css-extract-plugin
export var dropdownButton = "_1a-0";
export var fullWidthDropdownButton = "_1a-1";
export var icon = "_1a-3";
export var iconPlaceholder = "_1a-2";
export var menuItemRow = "_1a-9";
export var separator = "_1a-e";
export var shortcutContainer = "_1a-7";
export var shortcutContainerFilled = "_1a-8";
export var shortcutIconLg = "_1a-6";
export var shortcutIconMd = "_1a-5";
export var shortcutIconSm = "_1a-4";
export var submenuChevron = "_1a-d";
export var submenuDropdown = "_1a-a";
export var submenuTriggerRow = "_1a-b";
export var submenuTriggerRowOpen = "_1a-c";